import { useState } from "react";
import { AtomIcon } from "./AtomIcon";

interface TokenGateProps {
  onSubmit: (token: string) => void;
}

export function TokenGate({ onSubmit }: TokenGateProps) {
  const [token, setToken] = useState("");
  const [error, setError] = useState<string | null>(null);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const trimmed = token.trim();
    if (!trimmed) {
      setError("Please enter your access token.");
      return;
    }
    if (!/^[\x21-\x7e]+$/.test(trimmed)) {
      setError("Token contains invalid characters. Check your clipboard.");
      return;
    }
    onSubmit(trimmed);
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <AtomIcon size={56} />
          <div style={{ textAlign: "center" }}>
            <div className="auth-title">MUSE</div>
            <div className="auth-subtitle">Studio</div>
          </div>
        </div>

        <p style={{ color: "var(--text-secondary)", textAlign: "center", margin: 0 }}>
          Enter your access token to continue.
        </p>

        <form
          onSubmit={handleSubmit}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "var(--space-4)",
            width: "100%",
          }}
        >
          <input
            type="password"
            className="welcome-name-input"
            placeholder="Access token"
            value={token}
            onChange={(e) => { setToken(e.target.value); setError(null); }}
            autoFocus
            autoComplete="off"
          />

          {error && <div className="auth-error">{error}</div>}

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: "100%", maxWidth: "320px" }}
            disabled={!token.trim()}
          >
            Enter Studio
          </button>
        </form>
      </div>
    </div>
  );
}
